import TrendsTab from './TrendsTab'

export default TrendsTab
